import gql from 'graphql-tag';

export const LISTING_NAVIGATION_FRAGMENT = gql`
    fragment LISTING_NAVIGATION_FRAGMENT on BackToResultsLink {
        linkType
        uri
    }
`;
